import Moment from "moment";

const MOMENT_JS_FORMAT_DATE = "M/D/YYYY";
const MOMENT_JS_FORMAT_TIME = "h:mm a";

export function formatIsoDateAsLocalTimezoneDate(iso_date: string) {
  return Moment(iso_date).format(MOMENT_JS_FORMAT_DATE);
}

export function formatIsoDateAsLocalTimezoneTime(iso_date: string) {
  return Moment(iso_date).format(MOMENT_JS_FORMAT_TIME);
}
